<ng-container *ngIf="user">
    <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<h2 style="text-align: center; padding-top: 20px">Questionari {{type.toUpperCase()}} di {{patient.name}} {{patient.surname}}</h2>

<div class="container">

    <ng-container *ngIf="toShow !== null && toShow.length > 0; else notFound">
        <mat-list>

            <ng-container *ngIf="(this.type.localeCompare('clinical-sccai') === 0 ||
                            this.type.localeCompare('hads') === 0 ||
                            this.type.localeCompare('hbi') === 0 ||
                            this.type.localeCompare('ibd-disk') === 0 ||
                            this.type.localeCompare('miah-cd') === 0 ||
                            this.type.localeCompare('miah-uc') === 0 ||
                            this.type.localeCompare('mmas8') === 0 ||
                            this.type.localeCompare('patient-sccai') === 0 ||
                            this.type.localeCompare('phq9') === 0 ||
                            this.type.localeCompare('ibdq') === 0 ||
                            this.type.localeCompare('lars') === 0 ||
                            this.type.localeCompare('sibdq') === 0 ) && toShow">

                <div style="text-align:center">
                    <button mat-raised-button color="primary" (click)="showHideGraph()">
            <ng-container *ngIf="!hide">Nascondi</ng-container>
            <ng-container *ngIf="hide">Mostra</ng-container>
            grafico</button>
                </div>

                <ng-container *ngIf="!hide">
                    <mat-card style="margin-top: 20px" class="mat-elevation-z5">
                        <div style="text-align: center">
                            <h3>Situazione: {{diseaseActivity}}</h3>
                            <h3>Andamento medio</h3>

                            <div style="display: block; text-align: center; margin: auto">
                                <div class="chartAreaWrapper">
                                    <div class="chartWrapper">
                                        <canvas baseChart #baseChart="base-chart" [datasets]="lineChartData" [labels]="lineChartLabels" [chartType]="lineChartType" [options]="lineChartOptions">

                      </canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-card>

                </ng-container>
            </ng-container>

            <ng-container>
                <div style="padding-bottom: 20px"></div>

                <mat-card class="container mat-elevation-z5">
                    <div style="text-align: center; margin-top: 10px">
                        <button style="font-size: 15px" mat-button [matMenuTriggerFor]="filterResults">Filtra risultati</button> &nbsp;&nbsp;
                        <button style="font-size: 15px" mat-button (click)="selectionMode()">Seleziona</button>
                        <div style="margin-left: 5px; margin-top: 8px">
                            <ng-container *ngIf="selection">
                                <button style="font-size: 14px; margin-top: 8px" mat-raised-button color="primary" (click)="selectAll()">Seleziona tutti</button> &nbsp;
                                <button style="font-size: 14px; margin-top: 8px" mat-raised-button color="primary" (click)="deselectAll()">Deseleziona tutti</button> &nbsp;
                                <button style="font-size: 14px; margin-top: 8px" mat-raised-button color="primary" (click)="evaluationSelected()">Valida</button> &nbsp;
                                <button style="font-size: 14px; margin-top: 8px" mat-raised-button color="warn" (click)="warningSelected()">Segnala</button>
                            </ng-container>
                        </div>
                    </div>
                    <mat-menu #filterResults="matMenu" yPosition="below" xPosition="after">
                        <div fxLayout="column wrap">
                            <mat-checkbox class="example-margin" [(ngModel)]="read" (ngModelChange)="filter()" (click)="$event.stopPropagation();">Letti</mat-checkbox>
                            <mat-checkbox class="example-margin" [(ngModel)]="notRead" (ngModelChange)="filter()" (click)="$event.stopPropagation();">Non letti</mat-checkbox>
                            <mat-checkbox class="example-margin" [(ngModel)]="warned" (ngModelChange)="filter()" (click)="$event.stopPropagation();">Segnalati</mat-checkbox>
                            <mat-checkbox class="example-margin" [(ngModel)]="evaluated" (ngModelChange)="filter()" (click)="$event.stopPropagation();">Validati</mat-checkbox>
                        </div>
                    </mat-menu>
                    <table mat-table [dataSource]="dataSource">

                        <ng-container matColumnDef="results">
                            <th mat-header-cell *matHeaderCellDef>Risultati</th>
                            <td mat-cell *matCellDef="let result; let i = index">
                                <div fxLayout="row wrap">
                                    <ng-container *ngIf="selection; else normalMode">
                                        <mat-checkbox style="margin-right: 10px; margin-top: 1px" [(ngModel)]="allCheck[i]" (change)="selectItem(result, i)"></mat-checkbox>
                                    </ng-container>
                                    <ng-template #normalMode>
                                        <mat-icon class="folder">folder</mat-icon>
                                    </ng-template>
                                    <div style="cursor: pointer; vertical-align: middle; margin-left: 10px; margin-top: 1px" (click)="goTo(result)">
                                        {{result.id.split('-')[0]}}
                                        <ng-container *ngIf="type.includes('clinical')"> {{printDoctorInfo(result.doctorID)}}
                                        </ng-container>
                                    </div>
                                    <ng-container *ngIf="type.localeCompare('hbi') === 0 || type.localeCompare('clinical-hbi') === 0">
                                        <ng-container *ngIf="result.finalScore < 5">
                                            <mat-icon class="icon" style="color: mediumseagreen">thumb_up</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="result.finalScore >= 5 && result.finalScore <= 7">
                                            <mat-icon class="icon" style="color: #fff73b">error</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="result.finalScore > 7">
                                            <mat-icon class="icon" style="color: red">error</mat-icon>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="type.localeCompare('patient-sccai') === 0 || type.localeCompare('clinical-sccai') === 0">
                                        <ng-container *ngIf="result.finalScore < 5">
                                            <mat-icon class="icon" style="color: mediumseagreen">thumb_up</mat-icon>
                                        </ng-container>
                                        <ng-container *ngIf="result.finalScore >= 5">
                                            <mat-icon class="icon" style="color: red">error</mat-icon>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </mat-card>
            </ng-container>
        </mat-list>
    </ng-container>

</div>

<ng-template #notFound>
    <mat-card class="mat-elevation-z5">
        <h3 style="text-align: center;">Nessun questionario trovato. Torna indietro.</h3>
    </mat-card>
</ng-template>